import type { Theme, ThemeType } from '@festina-life/fplus-monaco'

export const MonacoColors: (
  themeType: ThemeType,
  theme: Theme,
) => Record<string, string> = (themeType) => {
  if (themeType === 'FPlusDark') {
    return {
      'editor.foreground': '#f8fafc', // --color-slate-50
      'editorSuggestWidget.background': '#1d293d', // --color-slate-800
      'editorSuggestWidget.highlightForeground': '#f8fafc', // --color-slate-50
      'editorSuggestWidget.selectedBackground': '#314158', // --color-slate-700
    }
  }

  return {} as Record<string, string>
}
